export default {
    namespaced: true,
    state: {
        storeOptionList: [],
        storeOptionV1List: []
    },
    mutations: {
        SET_OPTION_LIST(state, list) {
            state.storeOptionList = list;
        },
        UPDATE_OPTION_ITEM(state, item, option_id) {
            let index = state.storeOptionList.findIndex((element) => element.option_id == option_id);
            state.storeOptionList.splice(index, 1, item);
        },
        ADD_OPTION_ITEM(state, item) {
            state.storeOptionList.push(item);
        },
        SET_V1_OPTION_LIST(state, list) {
            state.storeOptionV1List = list;
        },
        REMOVE_OPTION_ITEM(state, option_id) {
            let index = state.storeOptionList.findIndex((element) => element.option_id == option_id);
            state.storeOptionList.splice(index, 1);
        }
    },
    actions: {
        async FETCH_OPTION_LIST({ commit, dispatch, }, store_id) {
            let url =
                `/merChant/bof_get_option_choice?store_id=${store_id}`;
            let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
                root: true
            });
            if (res === false) {
            } else {
                commit("SET_OPTION_LIST", res.data);
            }
        },
        async FETCH_V1_OPTION_LIST({ commit, dispatch, }, store_id) {
            let url =
                `/merChant/bof_get_old_option_choice?store_id=${store_id}`;
            let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
                root: true
            });
            console.log(`OLD`, res);
            if (res === false) {
            } else {
                commit("SET_V1_OPTION_LIST", res.data);
            }
        },
        async EDIT_OPTION_ITEM({ commit, dispatch, }, form) {
            for (let val of form.option_choice) {
                if (val.choice_id == null) {
                    delete val.choice_id
                }
            }
            let url =
                `/merChant/bof_update_option_choice`;
            let response = await dispatch("fetchGeneral/axiosPathPutData", { url, form }, {
                root: true
            });
            if (response === false) return false;
            if (response.msg === false) return false;
            commit("UPDATE_OPTION_ITEM", response.data);
            return true;
        },
        async CREATE_OPTION_ITEM({ commit, dispatch, }, form) {
            delete form.option_id;
            for (let val of form.option_choice) {
                delete val.choice_id
            }
            let url =
                `/merChant/bof_create_option_choice`;
            let response = await dispatch("fetchGeneral/axiosPathPostData", { url, form }, {
                root: true
            });
            if (response === false) return false;
            if (response.msg === false) return false;
            commit("ADD_OPTION_ITEM", response.data);
            return true;
        },
        async DELETE_OPTION_ITEM({ commit, dispatch, }, option_id) {
            let url =
                `waiting for api${option_id}`;
            let response = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
                root: true
            });
            if (response === false) return false;
            if (response.msg === false) return false;
            commit("REMOVE_OPTION_ITEM", response.data);
            return true;
        },
        async TRANSFER_V1_OPTION(payload) {

        }
    },
    getters: {

    }
};
